import React, { useState } from "react";
import Slide from "@material-ui/core/Slide";
import { connect } from "react-redux";
import { get_customerPannel_type, get_lang, get_LeftRightMenu, get_settings } from "../../../helper/UserData/userdate";
import { CanShowSetting, getLogoTypeByUrl } from "../../../helper/module";
import Drawer from "@material-ui/core/Drawer";
import {
  OpenCloseMenu,
  openCloseTransactionList,
  openCloseAboutUs,
  openCloseOrderHistory,
  OpenCloseSetting,
  OpenCloseSupport,
  OpenCloseMessageBox,
  openCloseWithdraw,
} from "../../../Redux/actions/actionNames";
import { ReactComponent as withdraw_cash_out } from "../../../static/IconProvider/withdraw/ic_cash_out.svg";

import { withTranslation, Trans } from "react-i18next";
import { Api_Get_Addressbook_list_AGW, Api_get_balance_AGW, Api_Get_Transactions_AGW } from "../../../helper/api/ApiGateway";
import Wallet, { MapHoc } from "./wallet";
import PaymentMethods from "./PaymentMethods";
import Addressbook from "./Addressbook";
import NewAddress from "./Addressbook/newAddress";
import { Invoive } from "../../../components/Menu/Invoive";

import WalletSvg from "./walletSvg";
import CardsSvg from "./cards";
import InvoiceSvg from "./invoiceSvg";
import OrderHistorySvg from "./orderHistorySvg";
import TransactionSvg from "./transactionSvg";
import SupportSvg from "./supportSvg";
import SettingSvg from "./settingSvg";
import AboutusSvg from "./aboutusSvg";
import AddressbookListSvg from "../../../components/svg/addressbookSvg";
import IconProviderSvgModifier from "../../../design-system/lib/IconProviderSvgModifier";
 

const styles = theme => ({
  ModalProps: {
    BackdropProps: {
      backgroundColor: "red"
    }
  }
});


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openInvoicesDialoge: false
    };
  }

  TransactionList_get = () => {
    Api_Get_Transactions_AGW(
      this.props.dispatch,
      {
        page: this.props.Transactions_page,
      },
      (call) => {
      }
    );
  };

  handleOpenInvoicesDialoge = () => {
    this.setState({
      openInvoicesDialoge: !this.state.openInvoicesDialoge,
    });
  };

  onclose = () => {
    this.setState({
      OpenAddressbook: false,
    }, () => {
      this.props.dispatch(OpenCloseMenu(false));
    });

 Api_Get_Addressbook_list_AGW(this.props.dispatch, { page: 1, perpage: 20, searchRegex: "" }, false);
    
  };

  openOrderHistory = () => {
    this.props.dispatch(OpenCloseMenu(false));
    this.props.dispatch(openCloseOrderHistory(true));
  };

  openOrderHistory = () => {
    this.props.dispatch(OpenCloseMenu(false));
    this.props.dispatch(openCloseOrderHistory(true));
  };

  openPaymentMeyhods = () => {
    this.props.dispatch(OpenCloseMenu(false));

    this.setState({
      openPaymentMeyhods: true
    })
  };


  PaymentMethodsonclose = () => {
    this.props.dispatch(OpenCloseMenu(false));

    this.setState({
      openPaymentMeyhods: false
    })
  }

  openTransactions = () => {
    this.props.dispatch(OpenCloseMenu(false));
    this.TransactionList_get();
    this.props.dispatch(openCloseTransactionList(true));
  };

  openSettings = () => {
    this.props.dispatch(OpenCloseMenu(false));
    this.props.dispatch(OpenCloseSetting(true));
  };

  openAboutus = () => {
    this.props.dispatch(OpenCloseMenu(false));
    this.props.dispatch(openCloseAboutUs(true));
  };


  openWithdraw = () => {
    this.props.dispatch(OpenCloseMenu(false));
    this.props.dispatch(openCloseWithdraw(true));
  };


  openSupport = () => {
    this.props.dispatch(OpenCloseMenu(false));
    this.props.dispatch(OpenCloseSupport(true));
  };


  openMessageBox = () => {
    this.props.dispatch(OpenCloseMenu(false));
    this.props.dispatch(OpenCloseMessageBox(true));
  };


  componentWillReceiveProps(nextProps) {
    nextProps.open && !this.props.open && Api_get_balance_AGW(this.props.dispatch, {}, (call) => { });

  }

  handleShowIncBalance = (bool) => {
    this.setState({
      OpenWallet: bool,
    }, () => {
      this.props.dispatch(OpenCloseMenu(false));
    });
  };

  handleShowAddressbook = (bool) => {
    this.setState({
      OpenAddressbook: bool,
    }, () => {
      this.props.dispatch(OpenCloseMenu(false));
    });

   Api_Get_Addressbook_list_AGW(this.props.dispatch, { page: 1, perpage: 20, searchRegex: "" }, false);
    
  };


  render() {

    return (
      <React.Fragment>

        <MapHoc><Wallet ShowComponent={false} OpenDialoge={this.state.OpenWallet} onClose={() => this.handleShowIncBalance(false)} /></MapHoc>
        
        <Addressbook ShowComponentMenu={false} OpenDialoge={this.state.OpenAddressbook} onclose={this.onclose} onClick={this.onclose} />
        {
          global.config.stripePublicApiKey && <PaymentMethods OpenDialoge={this.state.openPaymentMeyhods} onclose={this.PaymentMethodsonclose} />
        }

        <Drawer
          BackdropProps={{ invisible: true }}
          transitionDuration={400}
          anchor={get_LeftRightMenu()}
          open={this.props.open}
          mountOnEnter
          onClose={this.onclose}
        >
          <div className="MenuContainer">
            <div className="MenuHeaderContainer">
              <img onClick={this.openOrderHistory} src={global.config.logoTypeUrl} />
            </div>
            <div className="headerItemsContainer">

              <div
                onClick={() => this.handleShowIncBalance(true)}
                className="headerItemContainer"
              >
                <WalletSvg style={{
                      float: "left" ,
                      transform: "scale(.85)"
                }} />
                {/* <img src={wallet} /> */}
                <span className="span">
                  {" "}
                  <Trans i18nKey={"Wallett"}> </Trans>{" "}
                </span>
                <p className="Balance mouyp" >
                  <Trans i18nKey={"Balance"}> </Trans> :{" "}
                  <span>
                    {" "}
                    {this.props.balancecurrencyCode
                      ? Number(this.props.balance).toLocaleString(get_lang(), {
                        style: "currency",
                        currency: this.props.balancecurrencyCode,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                      : this.props.balance}{" "}
                  </span>{" "}
                </p>
              </div>


              {
                global.config.stripePublicApiKey && <div
                  className="headerItemContainer"
                  onClick={this.openPaymentMeyhods}
                >
                  <CardsSvg className="img" />
                  {/* <img src={card} /> */}
                  <span className="span">
                    {" "}
                    <Trans i18nKey={"paymentmethods"}> </Trans>{" "}
                  </span>
                </div>
              }


              {get_customerPannel_type() == "business" && <div
                className="headerItemContainer"
                onClick={this.handleOpenInvoicesDialoge}
              >
                <InvoiceSvg className="img"  />
                <span className="span">
                  {" "}
                  <Trans i18nKey={"Invoices"}> </Trans>{" "}
                </span>
              </div>
              }


          {get_settings().isWithdrawEnabled &&  <div className="headerItemContainer" onClick={this.openWithdraw}>
            <IconProviderSvgModifier Icon={withdraw_cash_out} size="20" style={{float:"inline-start" , width :"20px"}}  className="img"  />

                <span className="span">
                  {" "}
                  <Trans i18nKey={"Withdraw"}> </Trans>{" "}
                </span>
              </div>}


              <div
                className="headerItemContainer"
                onClick={this.openOrderHistory}
              >
                <OrderHistorySvg className="img" />
                <span className="span">
                  {" "}
                  <Trans i18nKey={"Orderhistory"}> </Trans>{" "}
                </span>
              </div>

              <div
                className="headerItemContainer"
                onClick={this.openTransactions}
              >
                <TransactionSvg className="img" />
                <span className="span">
                  {" "}
                  <Trans i18nKey={"Transactions"}> </Trans>{" "}
                </span>
              </div>

              <div
                className="headerItemContainer"
                onClick={() => this.handleShowAddressbook(true)}
              >
                <AddressbookListSvg className="img" />
                <span className="span">
                  {" "}
                  <Trans i18nKey={"Addressbook"}> </Trans>{" "}
                </span>
              </div>

{/* 
      <div className="headerItemContainer" onClick={this.openMessageBox}>
                <Box_outlinebox_outline className="img Aboutus" />
                <span className="span">
                  {" "}
                  <Trans i18nKey={"MessageBox"}> </Trans>{" "}
                </span>
              </div> */}

           
              
              <div className="headerItemContainer" onClick={this.openSupport}>
                <SupportSvg className="img" />
                <span className="span">
                  {" "}
                  <Trans i18nKey={"Support"}> </Trans>{" "}
                </span>
              </div>


        

              <div className="headerItemContainer" onClick={this.openSettings}>
                <SettingSvg className="img" />
                <span className="span">
                  {" "}
                  <Trans i18nKey={"Settings"}> </Trans>{" "}
                </span>
              </div>

              <div className="headerItemContainer" onClick={this.openAboutus}>
                <AboutusSvg className="img" />
                <span className="span">
                  {" "}
                  <Trans i18nKey={"Aboutus"}> </Trans>{" "}
                </span>
              </div>


            </div>
          </div>
        </Drawer>

        <NewAddress />

        {get_customerPannel_type() == "business" && <Invoive open={this.state.openInvoicesDialoge} handleOpen={this.handleOpenInvoicesDialoge} />}

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  open: state.SharedData.openMenu,
  Transactions_page: state.Transactions.page,
  balancecurrencyCode: state.NewOrder.newOrder.balance.currencyCode,
  currencyCode: state.SharedData.WebSettings
    ? state.SharedData.WebSettings.currencyCode
    : null,
  balance: state.NewOrder.newOrder.balance.balance,

});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
